/* eslint-disable no-unused-vars */
import "./styles.css";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { useEvent } from "hooks/useEvent";
import ResultsTable from "../ResultsTable";
import { nameInitials } from "../scorecardItem/nameInitials";
import { Separator } from "../scorecardItem/Separator";

function StillPlay(usersListWithTotalQuota, teamsPlayUsersNoIndividual) {
  return (
    usersListWithTotalQuota(teamsPlayUsersNoIndividual)?.filter(
      (u) => u.stillPlay,
    ).length >= 1 && (
      <div>
        <Separator showTime teeTimeString="Still Playing" />
        {usersListWithTotalQuota(teamsPlayUsersNoIndividual)
          ?.filter((u) => u.stillPlay)
          .map((i) => (
            <div key={i.uid}>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  minHeight: 50,
                }}
              >
                <div
                  style={{ padding: 15 }}
                  className="scorecard-results--index"
                >
                  {" "}
                </div>
                <div>
                  <div className="scorecard-results--name">
                    {nameInitials(i.displayName)}
                  </div>
                  <div className="scorecard-results--hdcp">
                    HDCP {i.courseHandicap}
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    )
  );
}

function ScorecardResults({
  matchType,
  onUserSelected,
  usersArray,
  teamsPlay,
  secondBetMatchType,
  ballCount,
}) {
  const { eventId } = useParams();
  const { teeTimesSubmitted, numberOfTeeTimes } = useEvent(eventId) || [];

  const usersListWithTotalQuota = (data) =>
    data.map((user) => {
      const holesQuota = user.holes.reduce(
        (acc, obj) => (obj.quota && acc + obj.quota) || 0,
        0,
      );
      return {
        ...user,
        totalQuota: holesQuota - user.quota,
        stillPlay: !teeTimesSubmitted?.includes(user.playingEventId),
      };
    });

  const teamsPlayUsersNoIndividual = usersArray.filter(
    (user) => !user.individual,
  );

  const teamsPlayUsersIndividual = usersArray.filter((user) => user.individual);

  return (
    <>
      <ResultsTable
        matchType={matchType}
        secondBetMatchType={secondBetMatchType}
        usersList={usersListWithTotalQuota(teamsPlayUsersNoIndividual)?.filter(
          (player) =>
            teamsPlay
              ? teeTimesSubmitted?.includes(player.playingEventId)
              : player,
        )}
        teamsPlay={teamsPlay}
        onUserSelected={(phone) => onUserSelected(phone)}
        ballCount={ballCount}
        numberOfTeeTimes={numberOfTeeTimes}
      />
      {teamsPlay &&
        StillPlay(usersListWithTotalQuota, teamsPlayUsersNoIndividual)}
      {teamsPlayUsersIndividual.length ? (
        <ResultsTable
          matchType={matchType}
          secondBetMatchType={secondBetMatchType}
          usersList={usersListWithTotalQuota(teamsPlayUsersIndividual)}
          teamsPlay={false}
          individuals
          onUserSelected={(phone) => onUserSelected(phone)}
          ballCount={ballCount}
          numberOfTeeTimes={numberOfTeeTimes}
        />
      ) : null}
    </>
  );
}

ScorecardResults.propTypes = {
  matchType: PropTypes.number.isRequired,
  onUserSelected: PropTypes.func.isRequired,
  secondBetMatchType: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    [[null]],
  ]).isRequired,
  usersArray: PropTypes.arrayOf(
    PropTypes.shape({
      reduce: PropTypes.func,
      filter: PropTypes.func,
    }),
  ),
  teamsPlay: PropTypes.bool,
  ballCount: PropTypes.number,
};

ScorecardResults.defaultProps = {
  usersArray: [],
  teamsPlay: false,
  ballCount: null,
};

export { ScorecardResults };
